import { z } from 'zod'

/**
 * Enums do domínio — espelham os tipos `supply.*` do banco (migrations em
 * `supabase/migrations`). Mudou aqui, muda lá (e vice-versa).
 */

export const TASK_STATUSES = ['pendente', 'em_processo', 'realizada', 'cancelada'] as const
export const TaskStatusSchema = z.enum(TASK_STATUSES)
export type TaskStatus = z.infer<typeof TaskStatusSchema>

export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  pendente: 'Pendente',
  em_processo: 'Em processo',
  realizada: 'Realizada',
  cancelada: 'Cancelada',
}

export const TASK_PRIORITIES = ['baixa', 'media', 'alta', 'urgente'] as const
export const TaskPrioritySchema = z.enum(TASK_PRIORITIES)
export type TaskPriority = z.infer<typeof TaskPrioritySchema>

export const TASK_PRIORITY_LABEL: Record<TaskPriority, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  urgente: 'Urgente',
}

export const GLOBAL_ROLES = ['admin', 'gestor'] as const
export const GlobalRoleSchema = z.enum(GLOBAL_ROLES)
export type GlobalRole = z.infer<typeof GlobalRoleSchema>

/** `executor`: do time do responsável da área, com visão restrita (ADR 0006). */
export const AREA_ROLES = ['responsavel', 'colaborador', 'executor'] as const
export const AreaRoleSchema = z.enum(AREA_ROLES)
export type AreaRole = z.infer<typeof AreaRoleSchema>

export const AREA_ROLE_LABEL: Record<AreaRole, string> = {
  responsavel: 'Responsável',
  colaborador: 'Colaborador',
  executor: 'Executor',
}

/** Tipo da área (`supply.area.tipo`): agrupa o cargo em Usuários e Permissões. */
export const AREA_TIPOS = ['gestao', 'gerencia', 'operacao'] as const
export const AreaTipoSchema = z.enum(AREA_TIPOS)
export type AreaTipo = z.infer<typeof AreaTipoSchema>

export const AREA_TIPO_LABEL: Record<AreaTipo, string> = {
  gestao: 'Gestão',
  gerencia: 'Gerência',
  operacao: 'Operação',
}

export const ATA_STATUSES = ['rascunho', 'fechada', 'enviada'] as const
export const AtaStatusSchema = z.enum(ATA_STATUSES)
export type AtaStatus = z.infer<typeof AtaStatusSchema>

export const ATA_STATUS_LABEL: Record<AtaStatus, string> = {
  rascunho: 'Rascunho',
  fechada: 'Fechada',
  enviada: 'Enviada',
}

/** Presença de quem foi convocado para a ATA (`supply.ata_presenca`). */
export const ATA_PRESENCAS = ['pendente', 'presente', 'ausente'] as const
export const AtaPresencaSchema = z.enum(ATA_PRESENCAS)
export type AtaPresenca = z.infer<typeof AtaPresencaSchema>

export const ATA_PRESENCA_LABEL: Record<AtaPresenca, string> = {
  pendente: 'A confirmar',
  presente: 'Presente',
  ausente: 'Faltou',
}

export const DECISION_STATUSES =['aberta', 'convertida', 'concluida', 'descartada'] as const
export const DecisionStatusSchema = z.enum(DECISION_STATUSES)
export type DecisionStatus = z.infer<typeof DecisionStatusSchema>

export const DECISION_STATUS_LABEL: Record<DecisionStatus, string> = {
  aberta: 'Aberta',
  convertida: 'Virou tarefa/ação',
  concluida: 'Concluída',
  descartada: 'Descartada',
}

export const NOTIFICATION_KINDS = [
  'atribuicao',
  'mencao',
  'status',
  'prazo_amanha',
  'prazo_hoje',
  'atrasada',
  'decisao_prazo',
  'ata_fechada',
  'reuniao_atrasada',
  'decisao_vencida',
  'decisao_sem_prazo',
] as const
export const NotificationKindSchema = z.enum(NOTIFICATION_KINDS)
export type NotificationKind = z.infer<typeof NotificationKindSchema>

export const TASK_EVENT_KINDS = [
  'criada',
  'status_alterado',
  'quantidade_alterada',
  'executor_alterado',
  'prazo_alterado',
  'area_alterada',
  'editada',
  'q3_atualizada',
  'excluida',
  'restaurada',
] as const
export type TaskEventKind = (typeof TASK_EVENT_KINDS)[number]

export const TASK_EVENT_LABEL: Record<TaskEventKind, string> = {
  criada: 'criou a tarefa',
  status_alterado: 'mudou o status',
  quantidade_alterada: 'alterou a quantidade',
  executor_alterado: 'trocou o executor',
  prazo_alterado: 'alterou o prazo',
  area_alterada: 'mudou a área',
  editada: 'editou a tarefa',
  q3_atualizada: 'atualizou a Q3',
  excluida: 'mandou para a lixeira',
  restaurada: 'restaurou da lixeira',
}
